/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAdminElementRoom
 */
export interface OutputAdminElementRoom {
    /**
     * BrigadeID — бригада, до якої прив'язана кімната (скоуп заявок з неї). null — не прив'язано.
     * @type {number}
     * @memberof OutputAdminElementRoom
     */
    brigadeId?: number;
    /**
     * BrigadeName — назва бригади на момент запиту, щоб UI не тягнув довідник окремо.
     * @type {string}
     * @memberof OutputAdminElementRoom
     */
    brigadeName?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminElementRoom
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminElementRoom
     */
    name?: string;
}

/**
 * Check if a given object implements the OutputAdminElementRoom interface.
 */
export function instanceOfOutputAdminElementRoom(value: object): boolean {
    return true;
}

export function OutputAdminElementRoomFromJSON(json: any): OutputAdminElementRoom {
    return OutputAdminElementRoomFromJSONTyped(json, false);
}

export function OutputAdminElementRoomFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminElementRoom {
    if (json == null) {
        return json;
    }
    return {
        
        'brigadeId': json['brigadeId'] == null ? undefined : json['brigadeId'],
        'brigadeName': json['brigadeName'] == null ? undefined : json['brigadeName'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function OutputAdminElementRoomToJSON(value?: OutputAdminElementRoom | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'brigadeId': value['brigadeId'],
        'brigadeName': value['brigadeName'],
        'id': value['id'],
        'name': value['name'],
    };
}

